<template>
    <b-card class="bg-default-card no-padding">
        <b-tabs card>
            <b-tab :title="uLang('app.entity_details', { entity: lang('app.log') })" active>
                <table class="table" v-if="loaded">
                    <tr v-if="shouldEvenShowPermissionTable">
                        <td colspan="2">
                            <log-permission-table :log="log"/>
                        </td>
                    </tr>
                    <tr>
                        <td width="200">{{ uLang('app.subject') }}:</td>
                        <td>{{ log.subject }}</td>
                    </tr>
                    <tr>
                        <td width="200">{{ uLang('app.body') }}:</td>
                        <td v-html="formatBody(log.body)"></td>
                    </tr>
                    <tr>
                        <td width="200">{{ uLang('app.activity_date') }}:</td>
                        <td v-if="!log.action_date">{{ log.activity_date }}</td>
                        <td v-else>{{ log.action_date }}</td>
                    </tr>
                </table>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import LogPermissionTable from "../../../../components/elements/log-permission-table";
    export default {
        name: 'show',
        props: {
            relationId: {
                required: true,
            },
            logId: {
                required: true
            }
        },
        data() {
            return {
                log: null,
                loaded: false
            }
        },
        components: {LogPermissionTable},
        computed: {
            shouldEvenShowPermissionTable() {
                return this.loaded && this.log.who_can_see !== null
            }
        },
        mounted() {
            this.getLog()
        },
        methods: {
            formatBody(body) {
                return body ? body.replace(/\n/g, '<br>') : '';
            },
            async getLog() {
                const {data} = await window.axios.get(
                    route('logs.show', {log: this.logId})
                );

                this.log = data;

                this.loaded = true
            }
        },
    }
</script>

<style lang="css" scoped>
</style>
